import React, {Component, useState} from 'react';
import { Navigate } from 'react-router-dom';
import { useParams } from "react-router-dom";
import { useEffect } from 'react';
import { IoIosArrowBack } from "react-icons/io";
import { Button, Container, Row, Col, FormControl, FormLabel, Alert } from 'react-bootstrap';
import ItemService from "./services/item.service";
import SupplierDataService from "./services/supplier.service";
import UOMDataService from "./services/uom.service";
import MultiSelectControl from "./MultiSelectControl";
import { PageHeader, NewHeader } from './AuxiliaryFunctions';
import TopAndSideBar from './TopAndSideBar';
import Switch from "react-switch";
import { usdCurrencyFormat } from './numberFormats';


var newDate = new Date()
var gtDate = newDate.getDate().toString().padStart(2,'0') + '-' + (newDate.getMonth()+1).toString().padStart(2,'0') + '-' + newDate.getFullYear()

const EditItemsPage = (props) => {    
  let params = useParams();
  const [showerror, setShowerror] = useState(false);
  const [showsuccess, setShowsuccess] = useState(false);

  const [errmessage, setErrmessage] = useState('');
  const [succmessage, setSuccmessage] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const [itemid, setItemid] = useState(params.id);
  const [itempartnumber, setItempartnumber] = useState('');
  const [itemdescription, setItemdescription] = useState('');
  const [itemprice, setItemprice] = useState('');
  const [itemcost, setItemcost] = useState('');
  const [primaryuomid, setPrimaryuomid] = useState(0);
  const [suppliers, setSuppliers] = useState([]);
  //const [itemsuppliers, setItemuppliers] = useState([]);
  const [uoms, setUoms] = useState([]);
  const [selectedsuppliers, setSelectedsuppliers] = useState([]);
  const [selectedsupplierids, setSelectedsupplierids] = useState([]);
  const [finish_cabinet_box_case, setfinish_cabinet_box_case] = useState(null);
  const [finish_cabinet_door, setfinish_cabinet_door] = useState(null);
  const [doormaterial, setDoorMaterial] = useState(null);
  const [ebmaterial, setEBMaterial] = useState(null);
  const [defaultbackfinishcost, setDefaultBackFinishCost] = useState(null);
  const [ebrollcostcase, setEBRollCostCase] = useState(null);
  const [ebrollcostdoors, setEBRollCostDoors] = useState(null);
  const [toekicksetcsheetcost, setToeKicksEtcSheetcost] = useState(null);
  const [thickness, setThickness] = useState(null);
  const [materialwidth, setMaterialWidth] = useState(null);
  const [materialheight, setMaterialHeight] = useState(null);
  const [rollmaterial, setRollMaterial] = useState(null);
  const [rolldimensions, setRollDimensions] = useState(null);
  const [wastage_perc, setWastagePerc] = useState(null);
  const [vendor, setVendor] = useState(null);

  const onChangeItemDescription = (e) => {
    setItemdescription(e.target.value)
  } 
  
  const onChangeItemPrice = (e) => {
    setItemprice(e.target.value)
  } 

  const onChangeItemCost = (e) => {
    setItemcost(e.target.value)
  }   

  const onChangeUOM = (e) => {
    setPrimaryuomid(e.target.value)
  } 

  const onChangeFinishCabinetBoxCase = () => {
    setfinish_cabinet_box_case(!finish_cabinet_box_case);
  }

  const onChangeFinishCabinetDoor = () => {
    setfinish_cabinet_door(!finish_cabinet_door);
  }

  const onChangeDoorMaterial = () => {
    setDoorMaterial(!doormaterial);
  }

  const onChangeEBMaterial = () => {
    setEBMaterial(!ebmaterial);
  }

  const onChangeDefaultBackfinishCost = (e) => {
    setDefaultBackFinishCost(e.target.value);
  }

  const onChangeEBRollCostCase = (e) => {
    setEBRollCostCase(e.target.value);
  }

  const onChangeEBRollCostDoor = (e) => {
    setEBRollCostDoors(e.target.value);
  }

  const onChangeToeKicksEtcSheetCost = (e) => {
    setToeKicksEtcSheetcost(e.target.value);
  }

  const onChangeThickness = (e) => {
    setThickness(e.target.value);
  }

  const onChangeMaterialWidth = (e) => {
    setMaterialWidth(e.target.value);
  }

  const onChangeMaterialHeight = (e) => {
    setMaterialHeight(e.target.value);
  }

  const onChangeRollMaterial = (e) => {
    setRollMaterial(e.target.value);
  }

  const onChangeRollDimensions = (e) => {
    setRollDimensions(e.target.value);
  }  

  const onChangeWastagePerc = (e) => {
    setWastagePerc(e.target.value);
  }  

  const onChangeVendor = (e) => {
    setVendor(e.target.value);
  }

  const handleValidations = () => {
    if (itemdescription.length==0 || itemprice.length==0) {
      setErrmessage('Fields can not be empty.');
      setShowerror(true);
      return;
    }
    if (itemcost >= itemprice) {
      setErrmessage('Item price must be greater than item cost.');
      setShowerror(true);
      return;
    }

    saveItem();
  }

  let saveItem = ()  =>{   
    var data = {
      itemdescription: itemdescription,
      standardsellingunitprice: itemprice,
      itemsupplier: selectedsuppliers, 
      standardpurchaseunitprice: itemcost,
      finish_cabinet_box_case: finish_cabinet_box_case,
      finish_cabinet_door: finish_cabinet_door,
      doormaterial: doormaterial,
      ebmaterial: ebmaterial,
      defaultbackfinishcost: defaultbackfinishcost,
      ebrollcostcase: ebrollcostcase,
      ebrollcostdoors: ebrollcostdoors,
      toekicksetcsheetcost: toekicksetcsheetcost,
      thickness: thickness,
      materialwidth: materialwidth,
      materialheight: materialheight,
      rollmaterial: rollmaterial,
      rolldimensions: rolldimensions,
      wastage_perc: wastage_perc,
      vendor: vendor
    }    
    
    ItemService.update(params.id, data)
    .then(response => {
      setSubmitted(true);
      setSuccmessage('Item has been updated. Redirecting to item list...');
      setShowsuccess(true);
      //window.location.assign('/items');
    })
    .catch(e => {
      console.log(e);
    })        
  }  

  // This runs once when mounting
  useEffect(() => {
    retrieveItem(itemid);  
    retrieveUOMs();
    retrieveSuppliers();
    console.log(usdCurrencyFormat(defaultbackfinishcost));
  }, [])

  const retrieveItem = (itemid) => {
    ItemService.get(itemid)
      .then(response => {
        setItempartnumber(response.data.itempartnumber);
        setItemdescription(response.data.itemdescription);
        setItemprice(response.data.standardsellingunitprice);
        setItemcost(response.data.standardpurchaseunitprice);
        setPrimaryuomid(response.data.primaryuomId);
        setSelectedsuppliers(response.data.suppliers);
        setfinish_cabinet_box_case(response.data.finish_cabinet_box_case);
        setfinish_cabinet_door(response.data.finish_cabinet_door);
        setDoorMaterial(response.data.doormaterial);
        setEBMaterial(response.data.ebmaterial);
        setDefaultBackFinishCost(response.data.defaultbackfinishcost);
        setEBRollCostCase(response.data.ebrollcostcase);
        setEBRollCostDoors(response.data.ebrollcostdoors);
        setToeKicksEtcSheetcost(response.data.toekicksetcsheetcost);
        setThickness(response.data.thickness);
        setMaterialWidth(response.data.materialwidth);
        setMaterialHeight(response.data.materiallength);
        setRollMaterial(response.data.rollmaterial);
        setRollDimensions(response.data.rolldimensions);
        setWastagePerc(response.data.wastage_perc);
        setVendor(response.data.vendor);
        setSelectedsupplierids(response.data.suppliers.map(x=>x["id"]));
        console.log(response.data);
      })
      .catch(e => {
        console.log(e);
      });
  }

  const retrieveUOMs = () => {
    UOMDataService.getAll()
      .then(response => {
        setUoms(response.data);
        console.log(response.data);
      })
      .catch(e => {
        console.log(e);
      });
  }

  const retrieveSuppliers = () => {
    SupplierDataService.getAll()
      .then(response => {
        setSuppliers(response.data);
        console.log(response.data);
      })
      .catch(e => {
        console.log(e);
      });
  }   

  const goToItemsList = () => {
    window.location.assign('/items')
  }

  // This function is passed as props to a child component (functional component)
  // The function runs on the child component and the state of the parent selectedsuppliers gets updated
  // when the parent is a functional component: https://daveceddia.com/useeffect-hook-examples/#run-useeffect-on-state-change
  // when the parent is a class component: https://bobbyhadz.com/blog/react-pass-data-from-child-to-parent
  const handleSelect = (selValue) => {
    setSelectedsuppliers(selValue);
    console.log(selValue);
  }

  return (
    <>
    <div style={{display:"flex", flexDirection:"column",width:"100%"}}>
      <TopAndSideBar />
      <NewHeader headerTitle={"Edit Item"}/>

      <Container>
        <Row className='mb-2'>
          <Col className='col-md-3' sm={8}>
            <FormLabel className='mb-2'>Item Part Number:</FormLabel>       
            <FormControl style={{maxWidth:"300px"}} type="text" name="itempartnumber" id="itempartnumber" disabled defaultValue={itempartnumber}></FormControl>
          </Col>

          <Col className='col-md-3' sm={8}>
            <FormLabel className='mb-2'>Item Description:</FormLabel>       
            <FormControl style={{maxWidth:"300px"}} type="text" name="itemdescription" id="itemdescription" onChange={onChangeItemDescription} defaultValue={itemdescription}></FormControl>
          </Col>          

          <Col className='col-md-3' sm={8}>
            <FormLabel className='mb-2'>Material Cost (USD):</FormLabel>       
            <FormControl style={{maxWidth:"300px"}} type="number" name="itemprice" id="itemprice" onChange={onChangeItemPrice} defaultValue={itemprice}></FormControl>
          </Col>  
          
          {/** This is probably not needed  
          <Col className='col-md-3' sm={8}>
            <FormLabel className='mb-2'>Item Cost:</FormLabel>       
            <FormControl style={{maxWidth:"300px"}} type="number" name="itemcost" id="itemcost" onChange={onChangeItemCost} defaultValue={itemcost}></FormControl>
          </Col>          
          */}

          <Col className='col-md-3' sm={8}>
            <FormLabel className='mb-2'>Primary UOM:</FormLabel>       
            <FormControl as='select' onChange={onChangeUOM} disabled={true}>
              <option disabled> {/**disabled={true} does not work!*/}
                {"Select"}
              </option>
              {uoms.map((uom) => {
                return (
                  <>
                  <option key={uom.unitofmeasureabbrev} value={uom.id} selected={true}>
                    {uom.unitofmeasureabbrev}
                  </option>
                  </>
                );
              })}
            </FormControl>
          </Col>  
        </Row>

        <Row>
          <Col className='col-md-3' sm={8}>
            <FormLabel>Finish Cabinet Box Case</FormLabel>        
            <div className='d-flex justify-content-start align-items-center gap-4'>
              <Switch
                className="react-switch"
                checked={finish_cabinet_box_case}
                onChange={onChangeFinishCabinetBoxCase}
              />                                  
            </div>
          </Col> 

          <Col className='col-md-3' sm={8}>
            <FormLabel className='mb-2'>Default Back Finish Cost (USD):</FormLabel>       
            <FormControl style={{maxWidth:"300px"}} type="number" name="defaultbackfinishcost" id="defaultbackfinishcost" onChange={onChangeDefaultBackfinishCost} defaultValue={defaultbackfinishcost}></FormControl>
          </Col> 

          <Col className='col-md-3' sm={8}>
            <FormLabel className='mb-2'>EB Roll Cost Case (USD):</FormLabel>       
            <FormControl style={{maxWidth:"100px"}} type="number" name="ebrollcostcase" id="ebrollcostcase" onChange={onChangeEBRollCostCase} defaultValue={ebrollcostcase}></FormControl>
          </Col> 

           
        </Row>         

        <Row>
          <Col className='col-md-3' sm={8}>
            <FormLabel>Finish Cabinet Door</FormLabel>        
            <div className='d-flex justify-content-start align-items-center gap-4'>
              <Switch
                className="react-switch"
                checked={finish_cabinet_door}
                onChange={onChangeFinishCabinetDoor}
              />                                  
            </div>
          </Col> 

          <Col className='col-md-3' sm={8}>
            <FormLabel className='mb-2'>EB Roll Cost Doors (USD)</FormLabel>       
            <FormControl style={{maxWidth:"300px"}} type="number" name="ebrollcostdoors" id="ebrollcostdoors" onChange={onChangeEBRollCostDoor} defaultValue={ebrollcostdoors}></FormControl>
          </Col> 

          <Col className='col-md-3' sm={8}>
            <FormLabel className='mb-2'>Toe Kicks, etc (USD):</FormLabel>       
            <FormControl style={{maxWidth:"300px"}} type="number" name="toekicksetcsheetcost" id="toekicksetcsheetcost" onChange={onChangeToeKicksEtcSheetCost} defaultValue={toekicksetcsheetcost}></FormControl>
          </Col> 

        </Row>


        <Row>
          <Col className='col-md-3' sm={8}>
            <FormLabel>Door Material</FormLabel>        
            <div className='d-flex justify-content-start align-items-center gap-4'>
              <Switch
                className="react-switch"
                checked={doormaterial}
                onChange={onChangeDoorMaterial}
              />                                  
            </div>
          </Col> 

          <Col className='col-md-3' sm={8}>
            <FormLabel className='mb-2'>Thickness</FormLabel>       
            <FormControl style={{maxWidth:"300px"}} type="text" name="thickness" id="thickness" onChange={onChangeThickness} defaultValue={thickness}></FormControl>
          </Col> 

          <Col className='col-md-3' sm={8}>
            <FormLabel className='mb-2'>Material Width:</FormLabel>       
            <FormControl style={{maxWidth:"300px"}} type="number" name="materialwidth" id="materialwidth" onChange={onChangeMaterialWidth} defaultValue={materialwidth}></FormControl>
          </Col> 

          <Col className='col-md-3' sm={8}>
            <FormLabel className='mb-2'>Material Length:</FormLabel>       
            <FormControl style={{maxWidth:"300px"}} type="number" name="materialheight" id="materialheight" onChange={onChangeMaterialHeight} defaultValue={materialheight}></FormControl>
          </Col>          
        </Row>

        <Row>
          <Col className='col-md-3' sm={8}>
            <FormLabel>EB Material</FormLabel>        
            <div className='d-flex justify-content-start align-items-center gap-4'>
              <Switch
                className="react-switch"
                checked={ebmaterial}
                onChange={onChangeEBMaterial}
              />                                  
            </div>
          </Col> 

          <Col className='col-md-3' sm={8}>
            <FormLabel className='mb-2'>Roll Material</FormLabel>       
            <FormControl style={{maxWidth:"300px"}} type="text" name="rollmaterial" id="rollmaterial" onChange={onChangeRollMaterial} defaultValue={rollmaterial}></FormControl>
          </Col> 

          <Col className='col-md-3' sm={8}>
            <FormLabel className='mb-2'>Roll Dimension (lnft)</FormLabel>       
            <FormControl style={{maxWidth:"300px"}} type="number" name="rolldimensions" id="rolldimensions" onChange={onChangeRollDimensions} defaultValue={rolldimensions}></FormControl>
          </Col> 

          <Col className='col-md-3' sm={8}>
            <FormLabel className='mb-2'>Wastage Percentage</FormLabel>       
            <FormControl style={{maxWidth:"300px"}} type="number" name="wastage_perc" id="wastage_perc" onChange={onChangeWastagePerc} defaultValue={wastage_perc}></FormControl>
          </Col> 

        </Row>

        <Row>
          <Col className='col-md-3' sm={8}>
            <FormLabel className='mb-2'>Vendor:</FormLabel>       
            <FormControl style={{maxWidth:"300px"}} type="text" name="vendor" id="vendor" onChange={onChangeVendor} defaultValue={vendor}></FormControl>
          </Col>            
        </Row>

        <hr/>
        <Row>
          <FormLabel className='mb-2'>Select the autorized suppliers for this item:</FormLabel>       
          <MultiSelectControl loadmode={false} key={"s"} initialselectedids={selectedsupplierids} alloptions={suppliers} descField="suppliername" idField="id" selValue={handleSelect}></MultiSelectControl>
        </Row>
        {showerror && (
          <Alert variant="danger" onClose={() => setShowerror(false)} dismissible>
            <Alert.Heading>Error</Alert.Heading>
            <p>{errmessage}</p>
          </Alert>      
        )}
        {showsuccess && (
          <Alert variant="success" onClose={() => setShowsuccess(false)} dismissible>
            <Alert.Heading>Done</Alert.Heading>
            <p>{succmessage}</p>
          </Alert>      
        )} 
        <hr/>
        <Row className='mb-2'>
          <Col className='col-md-3'>
            <Button id='saveItem' onClick={handleValidations}>Save Item</Button>            
            <Button className='m-2' id='backToUsersList' onClick={goToItemsList}><IoIosArrowBack/></Button>            
          </Col>
        </Row>      
        {submitted ? (<Navigate push to="/items"/>) : null }                                     
      </Container>
    </div>
    </>
  )

}

export default EditItemsPage;

